<template>
  <div class="direction-scrolling-settings">
    <div class="direction-scrolling-wrapper">
      <div class="title">
        <h3>
          {{ titleText }}
        </h3>
        <MobileIcon v-if="isForMobile" />
        <DesktopIcon v-else />
      </div>
      <div class="direction-scrolling-container">
        <button
          v-for="direction in computedDirections"
          :key="direction.name"
          class="direction-icon"
          :class="{
            selected: isHorizontalSwipe === direction.value,
          }"
          @click="
            onSwipeDirectionChange({
              inputFor: isForMobile
                ? 'isHorizontalSwipeOnMobile'
                : 'isHorizontalSwipe',
              value: direction.value,
            })
          "
        >
          <component :is="direction.icon"></component>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DesktopIcon from "@/assets/svg/small-desktop-icon.svg?inline";
import MobileIcon from "@/assets/svg/small-mobile-icon.svg?inline";

export default {
  components: {
    DesktopIcon,
    MobileIcon,
  },

  props: {
    campaignFormatOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isForMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      directions: [
        {
          name: "vertical",
          value: false,
          icon: require("@/assets/svg/vertical-scroll.svg?inline"),
        },
        {
          name: "horizontal",
          value: true,
          icon: require("@/assets/svg/horizontal-scroll.svg?inline"),
        },
      ],
    };
  },

  computed: {
    formatObject() {
      return this.campaignFormatOptions;
    },
    isHorizontalSwipe() {
      return this.isForMobile
        ? this.formatObject.isHorizontalSwipeOnMobile
        : this.formatObject.isHorizontalSwipe || false;
    },
    computedDirections() {
      return this.directions;
    },
    titleText() {
      return this.isForMobile
        ? this.$t("shared.toggleBox.swipeDirectionMobile")
        : this.$t("shared.toggleBox.swipeDirection");
    },
  },
  methods: {
    onSwipeDirectionChange(e) {
      this.$emit("change-format-object", {
        inputFor: e.inputFor,
        value: e.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.direction-scrolling:hover {
  background-color: $settings-hover;
}
.direction-scrolling-settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .title {
    display: flex;
    align-items: center;
    gap: 8px;
    display: flex;
    font-weight: 400;
    margin-bottom: 8px;
    .right {
      transform: rotate(180deg);
    }
  }
  &:hover {
    background-color: $settings-hover;
  }
}
.direction-icon {
  background: none;
  padding: 0;
  margin-right: 2px;
  box-sizing: border-box;
  svg {
    .name {
      fill: $light-grey;
      stroke: $light-grey;
    }
  }
}
.direction-scrolling-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.direction-icon.selected svg rect {
  stroke: $dark-purple;
  stroke-width: 1.5px;
}
.direction-icon.selected svg .hand {
  fill: $dark-purple;
  stroke: $dark-purple;
}
.direction-icon.selected svg .text {
  fill: $dark-purple;
}
</style>
